import styled from "styled-components";

export default styled.div`
  position: relative;

  .title__wrapper {
    display: flex;
    align-items: flex-start;
    .title {
      flex: 1 1 auto;
      color: rgba(0, 0, 0, 0.87);
      font-size: 21px;
      font-weight: 400;
      margin-bottom: 20px;
      padding-top: unset;
    }
    .isHd {
      border: 2px solid rgba(0, 0, 0, 0.87);
      font-size: 16px;
      padding: 0 5px;
      border-radius: 5px;
      margin-left: 10px;
    }
  }

  .additional__wrapper {
    position: relative;
    .fields {
      padding-bottom: 5px;
    }
    .label,
    .value {
      font-size: 14px;
      letter-spacing: 0.24px;
      color: rgba(0, 0, 0, 0.6);
    }
    .label {
      font-weight: 600;
      margin-right: 10px;
    }
    .value {
      font-weight: 400;
    }
    .location {
      display: inline-block;
      width: 235px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  @media screen and (max-width: 991px) {
    .title__wrapper {
      position: relative;
      .title {
        font-size: 16px;
      }
      .isHd {
        position: absolute;
        bottom: -20px;
        right: 0;
      }
    }

    .fields {
      display: flex;

      .label {
        min-width: 100px;
      }
      .label,
      .value {
        font-size: 12px;
      }
    }
  }
`;
